import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./Login.css";
import Footer from "../components/Footer";

import bgVideo from "../assets/bgVideo.mp4";
import leftLogo from "../assets/ciallogo.png";
import rightLogo from "../assets/krrlogo.jpg";

const API_URL = process.env.REACT_APP_API_URL;

function ResetPassword() {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const token = searchParams.get("token") || "";

    const [newPassword, setNewPassword] = useState("");

    const [confirmPassword, setConfirmPassword] = useState("");

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (newPassword !== confirmPassword) {

            toast.error("Passwords don't match.");
            return;

        }

        if (newPassword.length < 6) {

            toast.error("Password must be at least 6 characters.");
            return;

        }

        setIsSubmitting(true);

        try {

            const res = await fetch(`${API_URL}/portal/reset-password`, {

                method: "POST",

                headers: { "Content-Type": "application/json" },

                body: JSON.stringify({ token, new_password: newPassword })

            });

            const data = await res.json();

            if (data.status) {

                toast.success("Password reset successfully. Please log in.");

                setTimeout(() => navigate("/login"), 1500);

            } else {

                toast.error(data.message || "Could not reset password.");

            }

        } catch (err) {

            toast.error("Could not reach the server. Please try again.");

        } finally {

            setIsSubmitting(false);

        }

    };

    if (!token) {

        return (

            <div className="login-page">

                <video autoPlay loop muted playsInline className="login-bg-video">
                    <source src={bgVideo} type="video/mp4" />
                </video>

                <div className="login-card">

                    <div className="login-logos">
                        <img src={leftLogo} alt="CIAL" className="login-logo" />
                        <img src={rightLogo} alt="KRR" className="login-logo" />
                    </div>

                    <h2>Reset Password</h2>

                    <p>
                        This link is missing its reset token. Please use the link
                        from the password reset email, or request a new one.
                    </p>

                    <Link to="/forgot-password" className="login-btn" style={{ display: "block", textAlign: "center", textDecoration: "none" }}>
                        Request a New Link
                    </Link>

                </div>

                <Footer />

            </div>

        );

    }

    return (

        <div className="login-page">

            <video autoPlay loop muted playsInline className="login-bg-video">
                <source src={bgVideo} type="video/mp4" />
            </video>

            <ToastContainer position="top-right" autoClose={3000} />

            <div className="login-card">

                <div className="login-logos">
                    <img src={leftLogo} alt="CIAL" className="login-logo" />
                    <img src={rightLogo} alt="KRR" className="login-logo" />
                </div>

                <h2>Set New Password</h2>

                <form onSubmit={handleSubmit}>

                    <div className="form-group">

                        <label>New Password</label>

                        <input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            disabled={isSubmitting}
                        />

                    </div>

                    <div className="form-group">

                        <label>Confirm Password</label>

                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            disabled={isSubmitting}
                        />

                    </div>

                    <button type="submit" className="login-btn" disabled={isSubmitting}>
                        {isSubmitting ? "Resetting..." : "Reset Password"}
                    </button>

                </form>

            </div>

            <Footer />

        </div>

    );

}

export default ResetPassword;
